import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import alarm from './alarm2.mp3';

class App extends React.Component{
  constructor(props){
    super(props);

    this.state={
      breakTime:5*60000,
      sessionTime:25*60000,
      minute:25*60000,
      seconds:'00',
      play:false,
      isBreak:false,
      breakMin:5*60000
    };

    this.increaseBreak=this.increaseBreak.bind(this);
    this.decreaseBreak=this.decreaseBreak.bind(this);
    this.increaseSession=this.increaseSession.bind(this);
    this.decreaseSession=this.decreaseSession.bind(this);
    this.reset=this.reset.bind(this);
    this.countdown=this.countdown.bind(this);
    this.timeOut=null;

  }

  increaseBreak(){
    //Math.floor(minute/60000)
    if(Math.floor(this.state.breakTime/60000)+1<=60 && !this.state.play){
    this.setState({
      breakTime:this.state.breakTime+60000,
      breakMin:this.state.breakTime+60000
    });
  }
  console.log(this.state.breakMin);
}

  decreaseBreak(){
    if(Math.floor(this.state.breakTime/60000)-1>0 && !this.state.play){
    this.setState({
      breakTime:this.state.breakTime-60000,
      breakMin:this.state.breakTime+60000
    });
  }
}

  increaseSession(){
    if(Math.floor(this.state.sessionTime/60000)+1<=60 && !this.state.play){
    this.setState({
      sessionTime:this.state.sessionTime+60000,
      minute:this.state.sessionTime+60000
    });
  }
}
  decreaseSession(){
    if(Math.floor(this.state.sessionTime/60000)-1>0 && !this.state.play){
    this.setState({
      sessionTime:this.state.sessionTime-60000,
      minute:this.state.sessionTime-60000
    });
  }
}

reset(){
   clearInterval(this.timeOut);
   this.soundRef.pause();
   this.soundRef.currentTime=0;
  this.setState({
    breakTime:5*60000,
    sessionTime:25*60000,
    minute:25*60000,
    seconds:'00',
    play:false,
    isBreak:false
  });
}

timer(){
  //let timeLeft = this.state.minute;
  //let breakLeft=this.state.breakTime;
  //let timeOut;

  let timeLeft= !this.state.isBreak?  this.state.minute : this.state.breakMin;
  //if(!this.state.play) console.log('playing');
   if(timeLeft>0){
    timeLeft=timeLeft-1000;
  !this.state.isBreak?  this.setState({minute:timeLeft,seconds:((timeLeft%60000)/1000).toFixed(0)}) : this.setState({breakMin:timeLeft,seconds:((timeLeft%60000)/1000).toFixed(0)});
   this.timeOut = setTimeout(this.timer.bind(this),1000);
 //!this.state.play?  console.log(this.state.play) : clearTimeout(timeOut);
  console.log('Session '+timeLeft);
  //if(this.state.play) clearInterval(timeOut);
}
else{
  this.soundRef.load();
  this.soundRef.play();
this.setState({
  isBreak:!this.state.isBreak,
  minute:this.state.sessionTime,
  breakMin:this.state.breakTime
});
console.log('breakmin '+this.state.breakMin);
//timeLeft= !this.state.isBreak?  this.state.minute : this.state.breakMin;
this.timer();
}

}

countdown(){
this.setState({
  play:!this.state.play
});

!this.state.play? this.timer() : clearInterval(this.timeOut);
//console.log('after');
}

  render(){
    return(
      <div className='App'>
      <SessionBreak  breakTime={this.state.breakTime} sessionTime={this.state.sessionTime} increaseBreak={this.increaseBreak} decreaseBreak={this.decreaseBreak} increaseSession={this.increaseSession} decreaseSession={this.decreaseSession}/>
      <Clock minute={this.state.minute } seconds={this.state.seconds} breakMin={this.state.breakMin} isBreak={this.state.isBreak}/>
      <PauseReset reset={this.reset} play={this.state.play} countdown={this.countdown}/>
      <audio src={alarm} ref ={ref => {this.soundRef=ref;}} />
      </div>
    );
  }
}

const SessionBreak = ({ breakTime , sessionTime , increaseBreak, decreaseBreak, increaseSession, decreaseSession})=>{
  return(
    <div id='sessionBreak'>
    <div className='session'>
    <p> Session </p>
    <p><i className="fas fa-minus" onClick={decreaseSession}></i> {Math.floor(sessionTime/60000)} <i className="fas fa-plus" onClick={increaseSession}></i></p>
    </div>
    <div className='break'>
    <p> Break </p>
    <p> <i className="fas fa-minus" onClick={decreaseBreak}></i> {Math.floor(breakTime/60000)} <i className="fas fa-plus" onClick={increaseBreak}></i></p>
    </div>
    </div>
  );
}

const Clock = ({minute, seconds, breakMin, isBreak})=>{
  return(
    <div className='clock'>
    <div className='miniClock'>
    <div className='smallClock'>
    <p className='clockLabel'>{!isBreak? 'Session' : 'Break'}</p>
    <p className='time'>{!isBreak? Math.floor(minute/60000)<10? '0'+Math.floor(minute/60000): Math.floor(minute/60000) :  Math.floor(breakMin/60000)<10? '0'+Math.floor(breakMin/60000): Math.floor(breakMin/60000) } : {seconds<10 && seconds!=='00' ? '0'+seconds : seconds}</p>
    </div>
    </div>
    </div>
  );
}

const PauseReset=({reset,play,countdown})=>{
  return(
    <div className='pauseReset'>
    <i className={!play? "far fa-play-circle" : "far fa-pause-circle"} onClick={countdown}></i>
    <i className="fas fa-undo-alt" onClick={reset}></i>
    </div>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
